import React from 'react';
import en from './locales/en';
import fr from './locales/fr';
import es from './locales/es';
import it from './locales/it';

export const LOCALES = { en, fr, es, it };
export const LANG_NAMES = { en: 'EN', fr: 'FR', es: 'ES', it: 'IT' };
export const LANG_KEYS = ['en', 'fr', 'es', 'it'];

const STORAGE_KEY = 'thenewpm.lang';

function detectLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && LOCALES[saved]) return saved;
  } catch {}
  const browser = (
    (typeof navigator !== 'undefined' && navigator.language) || 'en'
  ).slice(0, 2).toLowerCase();
  return LOCALES[browser] ? browser : 'en';
}

const I18nContext = React.createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = React.useState(detectLang);

  const setLang = React.useCallback((l) => {
    if (!LOCALES[l]) return;
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch {}
  }, []);

  const value = React.useMemo(() => {
    const t = LOCALES[lang];
    const enFallback = LOCALES.en;
    return {
      lang,
      setLang,
      t,
      // Card text — falls back to English if missing in current locale
      tc: (cardId) => t.cards[cardId] || enFallback.cards[cardId] || {},
      // Ending text
      te: (endingId) => t.endings[endingId] || enFallback.endings[endingId] || {},
      // Role label
      tr: (role) => t.roles[role] || enFallback.roles[role] || role,
      // Stat meta { short, label }
      ts: (key) => t.stats[key] || enFallback.stats[key] || { short: key, label: key },
    };
  }, [lang, setLang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = React.useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
